import React from 'react';

export const FooterContext = React.createContext({
  theme: 'light',
  bgColor: 'white',
  textColor: 'black'
});

export const useShipmentFooter = () => React.useContext(FooterContext);
